module.exports = __webpack_public_path__ + "7d8db68e05ee477e745654d697efaff4.jpg";